import React, { useEffect, useState } from 'react'
import BrodcastFormProgress from '../../../Alarm/Broadcast/components/BrodcastFormProgress';
import Button from 'packages/novous_web/src/common/components/Button';
import { Tooltip, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import OrderDetailsTable from './OrderDetailsTable';
import RenewSubscriptionDataTable from './RenewSubscriptionDataTable';
import RenewOrderDetailsForm from './RenewOrderDetailsForm';
import InputField from 'packages/novous_web/src/common/components/InputField';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import useAxios from 'packages/novous_web/src/api/useAxios';
import useApiError from 'packages/novous_web/src/api/useApiError';

const RenewSubscription = () => {
    const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
    const navigate = useNavigate();
    const steps = ['Customer Selection', 'Order Details', 'Summary'];
    const [activeStep, setActiveStep] = useState(2);
    const [isSummaryView, setIsSummaryView] = useState(true);
    const location = useLocation();
    const initialRenewData = location.state;
    const [localRenewData, setLocalRenewData] = useState(initialRenewData);
    const isStartDateChanged = localRenewData?.startDate !== initialRenewData?.startDate;
    const isDurationChanged = localRenewData?.durations !== initialRenewData?.durations;
    const canContinue = isStartDateChanged || isDurationChanged;
    const [isInternal, setIsInternal] = useState<boolean>(false);
    useEffect(() => {
        const currentPath = window.location.pathname;
        const isInternalSubscription = currentPath.includes('internal-subscriptions');
        setIsInternal(isInternalSubscription);
    }, []);
    const {
        data: RenewChannelSubscriptionData,
        error: RenewChannelSubscriptionError,
        loading: RenewChannelSubscriptionLoading,
        fetchData: RenewChannelSubscriptionRequestData,
    } = useApiError<any>(API_ENDPOINTS.clientSubscription.RENEWS_SUBSCRIPTION, "POST"
    );

    const handleActiveState = (step: number) => {
        setActiveStep(step);
        setIsSummaryView(step === 2);
    };

    const handleBack = () => {
        if (activeStep > 0) {
            const newStep = activeStep - 1;
            setActiveStep(newStep);
            setIsSummaryView(newStep === 2);
        } else {
            navigate(-1);
        }
    };

    const handelSubmit = async () => {
        const formatDate = (dateStr: { split: (arg0: string) => [any, any, any]; }) => {
            const [day, month, year] = dateStr.split('/');
            return `${year}-${month}-${day}`;
        };

        const payload = {
            fleetId: localRenewData?.fleetId,
            subscriptionCode: localRenewData?.subscriptionCode,
            startDate: formatDate(localRenewData?.startDate),
            durations: localRenewData?.durations,
            channelType: isInternal
        };

        try {
            const response = await RenewChannelSubscriptionRequestData(payload);
            if (response?.status === 200 || response?.status === 201) {
                setToast({ open: true, message: response.message, type: 'success' });
                setTimeout(() => {
                    navigate(-1);
                }, 500);
            } else {
                setToast({ open: true, message: response.message, type: 'error' });
            }
        } catch (error: any) {
            setToast({ open: true, message: 'Error Occured while creating subscription', type: 'error' });
        }
    };

    useEffect(() => {
        if (RenewChannelSubscriptionError) {
            setToast({
                open: true,
                message: RenewChannelSubscriptionError,
                type: 'error',
            })
        }
    }, [RenewChannelSubscriptionError])

    return (
        <>
            <AlertToast
                open={toast.open}
                message={toast.message}
                onClose={() => setToast((prev) => ({ ...prev, open: false }))}
                type={toast.type as any}
            />
            <div className='flex flex-col gap-4 w-full h-full'>
                <div className="w-full mb-4">
                    <CustomIconButton
                        icon={<ArrowBack />}
                        text="Back"
                        background="transparent"
                        onClick={handleBack}
                    />
                </div>
                <div className='w-full flex flex-col gap-4 mb-4 h-full'>
                    <div className="w-full">
                        <div className="dashboard-header-left flex items-center justify-between">
                            <div className="flex flex-col items-start">
                                <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                                    {isSummaryView ? `Renew Subscription ${localRenewData?.subscriptionCode}` :
                                        activeStep === 0 ? `Renew Subscription ${localRenewData?.subscriptionCode}` : `Renew Subscription ${localRenewData?.subscriptionCode}`}
                                </Typography>
                            </div>
                            {isSummaryView && (
                                <Button
                                    text='Edit Orders'
                                    onClick={() => {
                                        setIsSummaryView(false);
                                        handleActiveState(1);
                                    }}
                                    fullWidth={false}
                                />
                            )}
                        </div>
                    </div>
                    <div className="flex justify-center items-center w-full">
                        <div className="flex w-[50%] border rounded-lg items-center border-gray-300 p-2 justify-center">
                            <BrodcastFormProgress steps={steps} activeStep={activeStep} />
                        </div>
                    </div>

                    {activeStep === 0 && !isSummaryView && (
                        <>
                            <div className="relative grid grid-cols-2 rounded-lg gap-4 mt-8">
                                <InputField
                                    label="Selected Customer"
                                    value={localRenewData?.userName || ''}
                                    onChange={() => { }}
                                    placeholder="Selected Customer"
                                    isDisabled
                                />
                            </div>
                            <div className="flex justify-end w-full gap-4 mb-4">
                                <Button
                                    text="Next"
                                    onClick={() => {
                                        handleActiveState(1);
                                    }}
                                    fullWidth={false}
                                />
                            </div>
                        </>
                    )}


                    {activeStep === 1 && !isSummaryView && (
                        <RenewOrderDetailsForm
                            renewData={localRenewData}
                            activeStep={activeStep}
                            isSummaryView={isSummaryView}
                            handleBack={handleBack}
                            handleActiveState={handleActiveState}
                            setIsSummaryView={setIsSummaryView}
                            onSave={(updatedData: any) => {
                                setLocalRenewData(updatedData);
                                setIsSummaryView(true);
                                setActiveStep(2);
                            }}
                        />
                    )}
                    {(activeStep === 2 || isSummaryView) && (
                        <RenewSubscriptionDataTable
                            renewData={localRenewData}
                            handleActiveState={handleActiveState}
                            isSummaryView={isSummaryView}
                        />
                    )}

                    {activeStep !== 1 && isSummaryView && (
                        <div className="flex justify-end w-full gap-4 mb-4">
                            <Tooltip title={!canContinue ? 'Please update Start Date or Duration to proceed' : ''}>
                                <span>
                                    <Button
                                        text="Continue"
                                        onClick={handelSubmit}
                                        disabled={!canContinue}
                                        fullWidth={false}
                                    />
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default RenewSubscription
